import { render, staticRenderFns } from "./GlobalConfirmationDialog.vue?vue&type=template&id=3e3c2f63&"
import script from "./GlobalConfirmationDialog.vue?vue&type=script&lang=ts&"
export * from "./GlobalConfirmationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports